define([
    "underscore",
    "backbone",
    "backbone.form"
], function (_, Backbone) {
    return Backbone.Form.extend({
        validation: {
            current_password: {
                required: true
            },
            password: {
                required: true
            },
            confirm_password: {
                equalTo: 'password'
            }
        },

        labels: {
            current_password: "Current Password",
            password: "New Password",
            confirm_password: "Confirm New Password"
        }
    });
});